if (!customElements.get('hdb-sales-card')) {
  customElements.define('hdb-sales-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', () => this.update());
      this.update();
    }
    update() {
      const option = this.querySelector('[data-sales-variant]')?.selectedOptions[0];
      if (!option) return;
      this.querySelector('[data-sales-price]').textContent = option.dataset.money;
      this.querySelectorAll('[data-sales-link]').forEach(link => link.href = option.dataset.url);
      this.querySelectorAll('[data-sales-unit]').forEach(unit => unit.hidden = unit.dataset.salesUnit !== option.value);
      const image = this.querySelector('img');
      if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    }
  });
}
if (!customElements.get('hdb-sales')) {
  customElements.define('hdb-sales', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', () => this.update());
      this.addEventListener('click', event => {
        const single = event.target.closest('[data-sales-add]');
        const group = event.target.closest('[data-sales-group]');
        if (!single && !group) return;
        event.preventDefault();
        const cards = single ? [single.closest('hdb-sales-card')] : this.selected();
        this.add(cards);
      });
      this.update();
    }
    selected() { return Array.from(this.querySelectorAll('hdb-sales-card')).filter(card => card.querySelector('[data-sales-check]')?.checked); }
    update() {
      const total = this.querySelector('[data-sales-total]');
      if (!total) return;
      const cards = this.selected();
      const cents = cards.reduce((sum, card) => sum + Number(card.querySelector('select').selectedOptions[0].dataset.price), 0);
      total.textContent = new Intl.NumberFormat(this.dataset.locale || 'de', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents / 100);
      this.querySelector('[data-sales-group]').disabled = cards.length === 0 || this.busy;
    }
    async add(cards) {
      if (this.busy || !cards.length) return;
      this.busy = true;
      const buttons = Array.from(this.querySelectorAll('button,select,input'));
      buttons.forEach(button => button.disabled = true);
      const message = this.querySelector('[data-sales-message]');
      message.textContent = '';
      const root = window.Shopify?.routes?.root || '/';
      let added = false;
      try {
        const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) throw new Error(this.dataset.error);
        const before = await response.json();
        const items = await Promise.all(cards.map(async card => {
          const option = card.querySelector('select').selectedOptions[0];
          if (this.classList.contains('hdb-sales--cart') && before.items.some(item => String(item.product_id) === card.dataset.productId)) throw new Error(this.dataset.stockError);
          const stockUrl = new URL(option.dataset.url, location.origin);
          stockUrl.searchParams.set('section_id', 'hdb-sales-stock');
          stockUrl.searchParams.set('_', Date.now());
          const stockResponse = await fetch(stockUrl, {cache:'no-store'});
          if (!stockResponse.ok) throw new Error(this.dataset.stockError);
          const stockDocument = new DOMParser().parseFromString(await stockResponse.text(), 'text/html');
          const stock = stockDocument.querySelector('[data-sales-stock-variant="' + option.value + '"]');
          if (!stock || Number(stock.dataset.price) !== Number(option.dataset.price)) throw new Error(this.dataset.stockError);
          const existing = before.items.filter(item => String(item.variant_id) === option.value).reduce((sum,item) => sum + item.quantity,0);
          if (existing + 1 > Number(stock.dataset.stock)) throw new Error(this.dataset.stockError);
          return {id:Number(option.value),quantity:1};
        }));
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections}}));
        const result = await fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname})});
        const payload = await result.json();
        if (!result.ok || payload.status) throw new Error(payload.description || this.dataset.error);
        added = true;
        const cartResponse = await fetch(root + 'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        const cart = await cartResponse.json();
        cart.sections = payload.sections;
        if (!window.FoxTheme?.pubsub || !cart.sections || Object.values(cart.sections).some(value => !value)) {
          location.assign(this.dataset.cartUrl); return;
        }
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart});
        cards.forEach(card => { const checkbox = card.querySelector('[data-sales-check]'); if (checkbox) checkbox.checked = false; });
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.show) drawer.show();
        else location.assign(this.dataset.cartUrl);
      } catch(error) {
        if (added) { location.assign(this.dataset.cartUrl); return; }
        message.textContent = error.message || this.dataset.error;
      } finally {
        this.busy = false;
        buttons.forEach(button => button.disabled = false);
        this.update();
      }
    }
  });
}
